import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Slide,
  Toolbar,
  alpha,
} from "@mui/material";
import {
  Close as CloseIcon,
  Delete as DeleteIcon,
  Download as DownloadIcon,
  MoreHoriz as MoreHorizIcon,
} from "@mui/icons-material";

function MultiSelectToolbar({
  multiSelected,
  onClose,
  onDownload,
  onRename,
  onDelete,
  onShare,
}: {
  multiSelected: string[] | null;
  onClose: () => void;
  onDownload: () => void;
  onRename: () => void;
  onDelete: () => void;
  onShare: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <Slide direction="up" in={multiSelected !== null} mountOnEnter unmountOnExit>
      <Paper
        elevation={12}
        sx={{
          position: "fixed",
          bottom: 16,
          left: 16,
          right: 16,
          borderRadius: 28,
          zIndex: (theme) => theme.zIndex.snackbar,
          backdropFilter: "blur(16px)",
          backgroundColor: (theme) =>
            alpha(
              theme.palette.mode === "dark"
                ? theme.palette.background.paper
                : theme.palette.common.white,
              theme.palette.mode === "dark" ? 0.82 : 0.9
            ),
        }}
      >
        <Toolbar sx={{ justifyContent: "space-evenly" }}>
          <IconButton color="primary" onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <IconButton
            color="primary"
            disabled={
              multiSelected?.length !== 1 || multiSelected[0].endsWith("/")
            }
            onClick={onDownload}
          >
            <DownloadIcon />
          </IconButton>
          <IconButton color="primary" onClick={onDelete}>
            <DeleteIcon />
          </IconButton>
          <IconButton
            color="primary"
            disabled={
              multiSelected?.length !== 1 || multiSelected[0].endsWith("/")
            }
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <MoreHorizIcon />
          </IconButton>
          {multiSelected?.length && (
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              PaperProps={{
                sx: {
                  borderRadius: 20,
                  py: 1,
                },
              }}
            >
              {multiSelected.length === 1 && (
                <React.Fragment>
                  <MenuItem onClick={onRename}>Rename</MenuItem>
                  <MenuItem onClick={onShare}>Share</MenuItem>
                </React.Fragment>
              )}
            </Menu>
          )}
        </Toolbar>
      </Paper>
    </Slide>
  );
}

export default MultiSelectToolbar;
